"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _core = require("@material-ui/core");
var _classnames = _interopRequireDefault(require("classnames"));
var _Card = _interopRequireDefault(require("./Card.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Card = function Card(_ref) {
  var title = _ref.title,
    subtitle = _ref.subtitle,
    icon = _ref.icon,
    iconColor = _ref.iconColor,
    children = _ref.children,
    py = _ref.py,
    px = _ref.px,
    _ref$p = _ref.p,
    p = _ref$p === void 0 ? 2.5 : _ref$p,
    paperStyle = _ref.paperStyle,
    bodyStyle = _ref.bodyStyle,
    headerAction = _ref.headerAction,
    _ref$elevation = _ref.elevation,
    elevation = _ref$elevation === void 0 ? 1 : _ref$elevation,
    footer = _ref.footer,
    dataIdProp = _ref['data-id'];
  var dataId = dataIdProp;
  if (!dataId && typeof title === 'string') {
    dataId = title.toLowerCase().replace(/ /g, '-');
  }
  var classes = (0, _Card.default)();
  var cssCardRoot = (0, _classnames.default)(_defineProperty({}, classes.depth1, elevation === 1), _defineProperty({}, classes.depth2, elevation === 2), _defineProperty({}, classes.depth3, elevation === 3), _defineProperty({}, classes.depth4, elevation === 4), _defineProperty({}, classes.depth5, elevation === 5));
  var cssCardHeader = (0, _classnames.default)(classes.cardHeader, _defineProperty({}, classes.noHeader, !title && !icon), _defineProperty({}, classes.onlyHeader, !children));
  return /*#__PURE__*/_react.default.createElement(_core.Paper, {
    className: cssCardRoot,
    classes: {
      root: classes.root
    },
    style: paperStyle,
    "data-id": dataId
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cssCardHeader
  }, /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: py,
    px: px,
    p: p
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.cardHeaderContent
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.titleContainer
  }, icon && /*#__PURE__*/_react.default.createElement(_core.Box, {
    color: iconColor,
    pr: 2
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.iconBox
  }, icon)), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h3", {
    className: classes.title,
    "data-id": dataId && "".concat(dataId, "-title")
  }, title), subtitle && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    className: classes.subtitle,
    "data-id": dataId && "".concat(dataId, "-subtitle")
  }, subtitle)))), headerAction))), children && /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: py,
    px: px,
    p: p,
    style: bodyStyle
  }, children), footer && /*#__PURE__*/_react.default.createElement(_core.Box, {
    py: 1.5,
    px: 2,
    p: p,
    className: classes.footer
  }, footer));
};
var _default = Card;
exports.default = _default;